module.exports = __webpack_public_path__ + "src/img/audioMask.3a6172df.png";